import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import React, { createContext, useState,useEffect,useContext } from 'react'
import { CoinList } from './config/api';
import { auth, db } from './firebase';

// Creating Context and putting to variable Crypto
const Crypto = createContext ();

//Whenever currency changes this is gonna run
const CryptoContext = ({ children }) => {
  const [currency, setCurrency] = useState("INR");
  const [symbol, setSymbol] = useState("₹");
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [alert, setAlert] = useState({
    open:false,
    message:"",
    type:"success",
  })

  const [watchlist, setWatchlist] = useState([])
  

  useEffect(() => {
    if (user) {
      const coinRef = doc(db, 'watchlist', user.uid);


     const unsubscribe = onSnapshot(coinRef,coin => {
        if(coin.exists()) {
          setWatchlist(coin.data().coins);
        }  else {
          console.log("No Items in Watchlist")
        }
      })

    return  () => {
      unsubscribe()
      }
    }
  
  }, [user])
  

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) setUser(user);
      else setUser(null);
    });
  }, []);

  

  //Fetch coins
  const fetchCoins = async () => {
    setLoading(true);
    // Passing current currency to API
    const { data } = await axios.get(CoinList(currency));
    setCoins(data);
    setLoading(false);
  };

  useEffect(() => {
    if (currency === "INR") setSymbol("₹");
    else if (currency === "USD") setSymbol("$");
  }, [currency]);

  // Sending all the things created here(currecy,symbol,setCurrency)
  //to our app(Header.js) using value.
  return (
    <Crypto.Provider
      value={{
        currency,
        symbol,
        setCurrency,
        coins,
        loading,
        fetchCoins,
        alert,
        setAlert,
        user,
        watchlist,
      }}
    >
      {children}
    </Crypto.Provider>
  );
};

export default CryptoContext;

//Use Context Hook
// Those who will call this function will get Crypto as return to them.
export const CryptoState = () => {
  return useContext(Crypto);
};
